// src/helpers/notifications/templates/news.ts

import { TemplateMeta } from '../notificationConfig';

export const newsTemplates: TemplateMeta[] = [
    {
        key: 'news.published',
        label: 'News Published',
        type: 'news',
        icon: 'ri-newspaper-line text-primary',
        title: d => `News: ${d.headline}`,
        subtitle: d => `By ${d.author}`,
    },
    {
        key: 'blog.posted',
        label: 'Blog Posted',
        type: 'news',
        icon: 'ri-article-line text-muted',
        title: d => `Blog: ${d.post_title}`,
        subtitle: d => `Read → ${d.url}`,
    },
    {
        key: 'vendor.update',
        label: 'Vendor Update',
        type: 'news',
        icon: 'ri-store-line text-info',
        title: d => `Vendor: ${d.vendor_name}`,
        subtitle: d => `See → ${d.doc_url}`,
    },
];
